import {store} from '../store'

export default (to, from, next) => {
  const currentUser = store.getters.user

  if (currentUser !== null && currentUser !== undefined && to.path !== '/signIn') {
    if (to.path === '/') {
      if (currentUser.role.toUpperCase() === 'ADMIN') {
        next({path: '/allTracking'})
      } else {
        next({path: '/myTracking'})
      }
    } else if (to.meta.roles.includes(currentUser.role.toUpperCase())) {
      next()
    }
  } else {
    const loginPath = window.location.pathname
    if (loginPath !== '/signIn') {
      next({name: 'signIn', query: {from: loginPath}})
    } else {
      next(false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/router/auth-guard.js